import  { useState } from 'react'
import { Footer } from '../../components/footer';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { TabContent, TabPane, Nav, NavItem, NavLink } from 'reactstrap';
import classnames from 'classnames';
import SlotHistory from './SlotHistory';
import { useGetCopartnerList } from '../appPages/api/dashboardApi';
import Loader from '../Loader/buttonLoad';

const SlotDetails = () => {
    const { data: getCoPartnerList, isLoading } = useGetCopartnerList()
    const { id } = useParams()
    const clubData = getCoPartnerList?.getClubDetails?.find(
        (club) => club.clubName.toLowerCase() === id.toLowerCase()
    );

    const location = useLocation();

    const navigate = useNavigate()

    const [activeTab, setActiveTab] = useState('slotHis');


    const toggle = tab => {
        if (activeTab !== tab) setActiveTab(tab)
    }

    return (


        <div>
            <div className="mainContent">
                {(isLoading) && <Loader />}
                <div className="pageContent def-py-30">
                    <div className='container'>
                        <div className="appPagetitle">
                            <button className='btn btnBack' onClick={() => navigate(location.state?.back ? '/' + location.state?.back : '/dashboard')}>
                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M4.16699 10H15.8337" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                    <path d="M4.16699 10L7.50033 13.3333" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                    <path d="M4.16699 10.0003L7.50033 6.66699" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                            </button> {' '}
                            {clubData?.clubName}
                        </div>
                        <div className='row'>
                            <div className="col-lg-12">



                                <div className="appcard mb-4 px-0 pb-2 cardbg">
                                    <div className="cardHeader border-bottom-0 px-4 pb-0">
                                        <div className='d-flex justify-content-between'>
                                            <Nav pills className='mypillsTabs'>
                                                <NavItem>
                                                    <NavLink
                                                        className={classnames({ active: activeTab === 'slotHis' })}
                                                        onClick={() => { toggle('slotHis'); }}
                                                    >
                                                        Slot History
                                                    </NavLink>

                                                </NavItem>
                                            </Nav>
                                            {/* <div>
                                                <span style={{ color: "#FCD535" }}>AvailableSlot: {clubData?.availableSlot}</span>
                                            </div> */}
                                        </div>


                                    </div>
                                    <div className="tabcnt">
                                        <TabContent activeTab={activeTab}>
                                            <TabPane tabId="slotHis">
                                                <SlotHistory slotNumber={clubData?.clubNumber} clubName={clubData?.clubName} back={location?.state?.back} />
                                            </TabPane>
                                        </TabContent>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
            <Footer />
        </div>
    )
}

export default SlotDetails;